export default __webpack_public_path__ + "static/media/Naija Shop.6b1698e6.png";